import type { WealthLevel } from "../../types";

export const wealthLevels: WealthLevel[] = [
  {
    name: "Beggar",
    startingCoin: "None",
    armour: { name: "None", ap: 0, dr: 0 },
  },
  {
    name: "Peasant",
    startingCoin: "2 silver",
    armour: { name: "Scrap Armour", ap: 1, dr: 0 },
  },
  {
    name: "Merchant/Artisan",
    startingCoin: "1 gold",
    armour: { name: "Light Armour", ap: 1, dr: 1 },
  },
  {
    name: "Wealthy",
    startingCoin: "3 gold",
    armour: { name: "Medium Armour", ap: 3, dr: 1 },
  },
  {
    name: "Noble",
    startingCoin: "5 gold (+ 5 silver/dawn)",
    armour: { name: "Heavy Armour", ap: 3, dr: 2 },
  },
  {
    name: "Royalty",
    startingCoin: "Unlimited",
    armour: { name: "Heavy Armour", ap: 3, dr: 2 },
  },
];
